import { useEffect } from 'react';
import { create } from 'zustand';

interface BreadcrumbState {
  /** Human labels for dynamic path segments (e.g. a KPI/project id → its name). */
  labels: Record<string, string>;
  setLabel: (segment: string, label: string) => void;
}

/**
 * Holds display labels for dynamic route segments so the breadcrumb trail can show an entity's
 * name instead of its opaque id. Detail pages register their id → name via {@link useBreadcrumbLabel}.
 */
export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  labels: {},
  setLabel: (segment, label) =>
    set((state) => (state.labels[segment] === label ? state : { labels: { ...state.labels, [segment]: label } })),
}));

/** Registers a breadcrumb label for a dynamic path segment (no-op until both values are present). */
export function useBreadcrumbLabel(segment: string | undefined, label: string | undefined) {
  const setLabel = useBreadcrumbStore((s) => s.setLabel);
  useEffect(() => {
    if (segment && label) setLabel(segment, label);
  }, [segment, label, setLabel]);
}
